import iban from 'iban';
import bic from 'bic';
export class BankHelper {
    static validate(input) {
        if (!input)
            return false;
        return iban.isValid(input);
    }
    static bicIsValid(input) {
        if (!input)
            return false;
        return bic.isValid(input);
    }
}
